import { type } from "../types/index";
import AuthService from "../services/auth.services";
import { getSucursales } from "./sucursales";
import { getSolicitudes } from "./solicitudes";
import { geolocalizacion } from "../helpers/functionGlobal";
import { getSecurityKey } from "../helpers/SecurityKey";

export const login = (user, password) => (dispatch) => {
  dispatch({ type: type.clearMessage });
  return AuthService.login(user, password).then(
    (data) => {
      console.log(data.Codigo);
      if (data.Codigo === 0) {
        dispatch({
          type: type.loginSucces,
          payload: data,
        });
        // Las sucursales ya no se toman del login: se obtienen de getSucursales
        // y, con la primera sucursal, se cargan las solicitudes.
        geolocalizacion().then((geo) => {
          const key = getSecurityKey();
          dispatch(getSucursales(user, key, geo.lt, geo.lg)).then((sucData) => {
            const sucursales = sucData?.Sucursales || [];
            if (sucursales.length > 0) {
              const primera = sucursales[0];
              // getSucursales rota la llave de seguridad, hay que releerla.
              const keySolic = getSecurityKey();
              dispatch(
                getSolicitudes(
                  user,
                  primera.CveDistribuidor,
                  primera.Clave,
                  primera.Vendedor,
                  keySolic,
                ),
              );
            }
          });
        });
      } else if (data.Codigo === 2) {
        dispatch({
          type: type.loginActPass,
          payload: {
            errorMessage: data.Mensaje,
            statusPass: 101,
          },
        });

        dispatch({
          type: type.olvidoEnvioContraseniaTem,
          payload: {
            paso: 2,
            email: user,
          },
        });
      } else if (data.Codigo === 4) {
        console.log(data.Mensaje);
        dispatch({
          type: type.loginActPass,
          payload: {
            errorMessage: data.Mensaje,
            statusPass: 100,
          },
        });

        dispatch({
          type: type.olvidoEnvioContraseniaTem,
          payload: {
            paso: 2,
            email: user,
            contraseniaTemporal: password,
          },
        });
      } else if (data.Codigo !== 0 && data.Codigo !== undefined) {
        console.log(111);
        dispatch({
          type: type.loginFail,
          payload: {
            errorMessage: data.Mensaje,
          },
        });
      } else {
        dispatch({
          type: type.loginFail,
          payload: {
            errorMessage:
              "Hubo un error en el servicio. Por favor, revista tu conexión a internet e inténtalo de nuevo.",
          },
        });
      }
      return Promise.resolve(data);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      dispatch({
        type: type.showAlertMessage,
      });
      return Promise.reject(message);
    },
  );
};

export const logout = () => (dispatch) => {
  AuthService.logout();
  // Limpiar la sucursal seleccionada para no arrastrar una selección obsoleta
  // (de una sesión anterior) al siguiente login.
  sessionStorage.removeItem("sucursalSeleccionada");
  dispatch({
    type: type.updateSucursalSelection,
    payload: null,
  });
  dispatch({
    type: type.clearMessage,
  });
  dispatch({
    type: type.logout,
  });
  dispatch({
    type: type.resetCotizador,
  });
  dispatch({
    type: type.resetSolicitud,
  });
};
